import { render, staticRenderFns } from "./EmployeeHealth.vue?vue&type=template&id=8b916cfa&lang=pug&"
import script from "./EmployeeHealth.vue?vue&type=script&lang=js&"
export * from "./EmployeeHealth.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "EmployeeHealth.vue"
export default component.exports